module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("f7ASb"))).then(() => parcelRequire('dJXJK'));